module.exports = __webpack_public_path__ + "static/media/youtube_btn.43ac7577.png";